import * as React from "react";
const SvgForce20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M13.127-.354 11.697 7.5h6.518L6.874 20.355 8.302 12.5H1.784L13.127-.354ZM6.216 10.5h4.481l-.572 3.146L13.784 9.5H9.302l.572-3.145L6.216 10.5Z",
      clipRule: "evenodd"
    })
  );
export default SvgForce20Px;
